import React, { useState, useEffect } from 'react';
import './LessonPlanPreview.css';

const slides = [
  {
    dimension: 'Explore',
    content: "Birds are extraordinary creatures with hollow bones, specialized feathers, and unique flight adaptations — signs of intentional creation, not random chance."
  },
  {
    dimension: 'Compare',
    content: "Just as planes are engineered with precision, birds are intricately designed for flight, navigation, and survival — yet far more advanced and self-sustaining."
  },
  {
    dimension: 'Question',
    content: "If planes can't build or fly themselves, how can birds — with migration, vision, and reproduction — be the product of chance or material causes?"
  },
  {
    dimension: 'Connect',
    content: "Birds reflect the Names of Allah: Al-Khaliq (Creator), Ar-Razzaq (Provider), Al-Hadi (Guide), through their design, sustenance, and navigation across Earth."
  },
  {
    dimension: 'Appreciate',
    content: "Reflect on the role of birds in pollination, song, migration, and balance. Say SubhanAllah for their beauty and function, and thank Allah for this blessing."
  }
];

const LessonPlanPreview = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 4500);
    return () => clearInterval(interval);
  }, []);

  const { dimension, content } = slides[index];

  return (
    <div className="lesson-plan-preview">
      <div className="lesson-slide" data-dimension={dimension}>
        <div className="lesson-slide-header">{dimension}</div>
        <p>{content}</p>
      </div>
    </div>
  );
};

export default LessonPlanPreview;
